/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TypeBulletinEditDto
 */
export interface TypeBulletinEditDto {
    /**
     * 
     * @type {number}
     * @memberof TypeBulletinEditDto
     */
    idtypeBulletin?: number;
    /**
     * 
     * @type {string}
     * @memberof TypeBulletinEditDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypeBulletinEditDto
     */
    libelle?: string | null;
}

/**
 * Check if a given object implements the TypeBulletinEditDto interface.
 */
export function instanceOfTypeBulletinEditDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TypeBulletinEditDtoFromJSON(json: any): TypeBulletinEditDto {
    return TypeBulletinEditDtoFromJSONTyped(json, false);
}

export function TypeBulletinEditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeBulletinEditDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idtypeBulletin': !exists(json, 'idtypeBulletin') ? undefined : json['idtypeBulletin'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
    };
}

export function TypeBulletinEditDtoToJSON(value?: TypeBulletinEditDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idtypeBulletin': value.idtypeBulletin,
        'code': value.code,
        'libelle': value.libelle,
    };
}

